import {PaymentOnTrial, PaymentFailed, PaymentDisputing, PaymentRegistered, PaymentUnregistered} from '../../app';

export default class AccountInformationController {
    constructor(
        AccountInformationService, $validation, Notification, $auth, SatellizerConfig, $state, $uibModal, 
        FileUploader, host, AuthService, $window, $translate, SubscriptionService
    ) {
        this.service = AccountInformationService;
        this.notify = Notification;
        this.$auth = $auth;
        this.satellizerConfig = SatellizerConfig;
        this.state = $state;
        this.modal = $uibModal;
        this.host = host;
        this.auth = AuthService;
        this.$window = $window;
        this.fileUploader = new FileUploader({
            url: this.service.host + '/api/accounts/logo',
            headers: {
                Authorization: `Bearer ${this.auth.getToken()}`,
                'X-Account-Token': this.auth.getAccountToken()
            },
            removeAfterUpload: true
        });
        this.trans = $translate.instant;
        this.cards = [];
        this.subscribe = SubscriptionService;
        // $validation
        //     .setExpression({
        //         accountAvailable: (value, scope, element, attrs) => {
        //             return this.service.isAccountAvailability(value).toPromise().then(
        //                 (exists) => {
        //                     this.accountUnavailable = false;
        //                     if (!exists) {
        //                         this.accountUnavailable = true;
        //                     }
        //                     return exists;
        //                 }, (exists) => exists
        //             );
        //         }
        //     })
        //     .setDefaultMsg({
        //         accountAvailable: {
        //             error: "Esta cuenta no está disponible"
        //         }
        //     });
    }

    $onInit() {
        this.subscriptions = [];

        const _ = this.trans;
        this.logoName = false;

        this.subscriptions.push(
            this.accountInfo.subscribe(
                (accountInfo) => {
                    this.account = accountInfo;
                    if (this.account.phone === null) {
                        this.account.phone = null;
                    }

                    if (this.account.country) {
                        this.subscriptions.push(
                            this.service.getTimezones(this.account.country).subscribe(
                                (timezones) => this.timezones = timezones
                            )
                        );
                    }

                    this.account_id = this.account.id;
                    this.subscriptions.push(
                        this.service.getAccountLogo(this.account_id, true).subscribe(
                            (resp) => {
                                if (resp && resp.hasOwnProperty('logo_name') && resp.logo_name) {
                                    this.fileName = resp.logo_name;
                                    this.logoName = true;
                                }else if(resp && resp.hasOwnProperty('logo') && resp.logo){
                                    this.fileName = 'Logo';
                                    this.logoName = true;
                                }else {
                                    this.fileName = _('Seleccionar logo');
                                }
                                
                            },
                            (error) => {
                                this.fileName = _('Seleccionar logo');
                                this.logoName = false;
                            }
                        )
                    );
                },
                (error) => console.log(error)
            )
        );

        this.subscriptions.push(
            this.userObservable.subscribe(
                (user) => this.user = user,
                (error) => console.log(error)
            )
        );
        this.nameAccount = '';
        this.accountUnavailable = true;
        this.fileUploader.onAfterAddingFile = () => {
            this.uploadLogo();
        }
        this.card = {};
        this.stripe = this.$window.stripe;
        const elements = this.stripe.elements();
        const style = {
            base: {
              color: '#32325d',
              lineHeight: '24px',
              fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
              fontSmoothing: 'antialiased',
              fontSize: '16px',
              '::placeholder': {
                color: '#000000'
              }
            },
            invalid: {
              color: '#fa755a',
              iconColor: '#fa755a'
            }
        };
        this.cardElement = elements.create('card', {style: style});
        this.cardElement.mount(document.getElementById('card-element'));
        this.cardElement.addEventListener('change', (event) => {
            let displayError = document.getElementById('card-errors');
            if (event.error) {
                displayError.textContent = event.error.message;
            } else {
                displayError.textContent = '';
            }
        });

        this.subscriptions.push(
            this.subscribe.getCustomerCards().subscribe((data) => {
                if (data.cards && data.cards.length) {
                    this.defaultCard = data.cards.find(card => card.default).token;
                    this.cards = data.cards;
                }
            })
        );

        this.isOnTrial = false;
        this.hasPendingPayment = false;
        this.subscriptions.push(
            this.subscribe.paymentStatus()
                .subscribe(status => {
                    this.isOnTrial = status === PaymentOnTrial;
                    this.hasPendingPayment = [
                        PaymentFailed, PaymentDisputing, PaymentRegistered, PaymentUnregistered
                    ].indexOf(status) > -1;
                })
        );

        console.log(`Point Of Sales: ${this.pointOfSalesCount}`);
    }
    $onDestroy() {
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }
    $onDestroy() {
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }

    renameUser() {
        const _ = this.trans;
        this.subscriptions.push(
            this.service.renameUser(this.user.first_name, this.user.last_name).subscribe(data => {
                if (data !== undefined) {
                    this.notify.success(_('Su nombre ha sido cambiado exitosamente'));
                }
            })
        );
    }

    chooseLanguage() {
        const _ = this.trans;
        this.subscriptions.push(
            this.service.chooseLanguage(this.user.language).subscribe(
                (data) => {
                    if (data !== undefined) {
                        this.notify.success(_('Su idioma ha sido cambiado exitosamente'));
                        this.$window.localStorage.userLanguage = data.language;
                        this.state.reload();
                    }
                }
            )
        );
    }

    modifyPassword() {
        const _ = this.trans;
        this.subscriptions.push(
            this.service.modifyPassword(this.password).subscribe(
                (data) => {
                    this.password = '';
                    this.notify.success(_('Su contraseña ha sido cambiada exitosamente'));
                }
            )
        );
    }

    saveInformation() {
        const _ = this.trans;
        this.subscriptions.push(
            this.service.saveInformation({
                identification: this.account.identification,
                address: this.account.address,
                phone: this.account.phone,
                country: this.account.country,
                timezone: this.account.timezone,
                language: this.account.language,
                currency: this.account.currency
            }).subscribe(
                (data) => {
                    this.notify.success(_('La información fue guardada exitosamente'));
                }
            )
        );
    }

    uploadLogo() {
        const _ = this.trans;
        this.fileUploader.uploadAll();
        this.fileUploader.onSuccessItem = () => {
            this.fileName = this.fileUploader.queue[0].file.name;
            this.logoName = true;
            this.notify.success(_('El logo ha sido agregado exitosamente'));
        }

        this.fileUploader.onErrorItem = () => {
            this.notify.error(_('El logo debe ser en un formato de imagen'));
        }
    }

    createAccount() {
        const _ = this.trans;
        this.subscriptions.push(
            this.service.createAccount(this.nameAccount).subscribe(
                (data) => {
                    this.notify.success(_('Cuenta creada exitosamente'));
                    this.state.reload();
                }
            )
        );
    }

    linkToOauth(provider) {
        const _ = this.trans;
        if (provider !== 'google') return;

        var currentUrl = this.satellizerConfig.providers[provider].url;
        var splitBoundary = currentUrl.lastIndexOf('/');
        this.satellizerConfig.providers[provider].url = [
            currentUrl.slice(0, splitBoundary), '/link',
            currentUrl.slice(splitBoundary)
        ].join('');
        this.$auth.authenticate(provider)
            .then(() => {
                this.notify.success(_(`Ha enlazado su usuario a su cuenta exitosamente.`));
                this.satellizerConfig.providers[provider].url = currentUrl;
            })
            .catch((error) => {
                if (error.message) {
                    this.notify.error(error.message);
                } else if (error.data) {
                    this.notify.error(error.data.message, error.status);
                } else {
                    this.notify.error(error);
                }
                this.satellizerConfig.providers[provider].url = currentUrl;
            });
    }

    onCountrySelect(country){
        this.account.country = country;
        this.subscriptions.push(
            this.service.getTimezones(country).subscribe(
                (timezones) => {
                    this.timezones = timezones;
                }
            )
        );
    }

    onTimezoneSelect(timezone){
        this.account.timezone = timezone;
    }


    logoLightbox() {
    var that = this;
      this.modal.open({
        animation: true,
        size: 'lg',
        templateUrl: 'display-logo-template.html',
        appendClassName: 'ngdialog-theme-plain',
        controller: ($scope, $uibModalInstance) => {
          "ngInject";

          $scope.logoUrl = that.service.host + '/api/accounts/logo/' + that.account_id + '?t=' + new Date().getTime();
          $scope.closeThisDialog = () => $uibModalInstance.close();
        }
      });

    }

    addPaymentMethod() {
        const _ = this.trans;

        this.stripe.createToken(this.cardElement).then(response => {
            const {token, error} = response;
            if (error) {
              const errorElement = document.getElementById('card-errors');
              errorElement.textContent = error.message;

              return;
            }

            const clientCard = angular.extend(this.card, token);
            this.subscriptions.push(
                this.subscribe.addPaymentMethod(clientCard)
                    .subscribe(
                        () => {
                            this.cards.push({
                                token: clientCard.card.id,
                                default: false,
                                last4: clientCard.card.last4
                            });

                            this.cardElement.clear();
                            this.notify.success(_('Nueva tarjeta agregada.'));
                        },
                        () => this.notify.error(_("No ha sido posible agregar la tarjeta, intente nuevamente."))
                    )
            );
        });
    }
    deletePaymentMethod(card, indexInArray) {
        if (card.default) { return; }

        const _ = this.trans;
        this.subscriptions.push(
            this.subscribe.deletePaymentMethod(card.token)
                .subscribe(
                    () => {
                        this.cards.splice(indexInArray, 1);
                        this.notify.success(_('Tarjeta eliminada.'));
                    },
                    () => this.notify.error(_("No ha sido posible eliminar la tarjeta, intente nuevamente."))
                )
        );
    }
    setDefaultPaymentMethod(card) {
        if (card.default) { return; }

        const _ = this.trans;
        this.subscriptions.push(
            this.subscribe.setDefaultPaymentMethod(card.token)
                .subscribe(
                    () => {
                        this.cards.forEach(c => {
                            if (c.default) {
                                c.default = false;
                            }
                        });
                        card.default = true;
                        this.defaultCard = card.token;
                    },
                    () => this.notify.error(_("No ha sido posible cambiar el método de pago."))
                )
        );
    }

    doSubscription() {
        const _ = this.trans;

        this.stripe.createToken(this.cardElement).then(response => {
            const {token, error} = response;
            if (error) {
                const errorElement = document.getElementById('card-errors');
                errorElement.textContent = error.message;

                return;
            }
    
            const clientCard = angular.extend(this.card, token);
            this.subscriptions.push(
                this.subscribe.subscribeCustomerViaStripe(clientCard)
                    .subscribe(
                        () => {
                            this.cards.push({
                                token: clientCard.card.id,
                                default: false,
                                last4: clientCard.card.last4
                            });

                            // Ideally, we would reset the form instead, in order to avoid
                            // the 'required field' message
                            // this.card.holder = '';
                            // this.card.email = '';

                            this.cardElement.clear();
                            this.notify.success(_("Usted ha sido suscrito de manera exitosa."));
                        },
                        () => this.notify.error(_("No ha sido posible procesar la suscripción, intente nuevamente."))
                    )
            );
        });
    }
    // cancelSubscription() {
    //     if (this.hasPendingPayment) { return; }

    //     this.subscriptions.push(
    //         this.subscribe.unsubscribe()
    //             .subscribe(
    //                 () => {
    //                 },
    //                 () => this.notify.error(_("No ha sido posible cancelar la suscripcion, intente nuevamente."))
    //             )
    //     );
    // }
}

AccountInformationController.$inject = [
    'AccountInformationService', '$validation', 'Notification', '$auth', 'SatellizerConfig', '$state', 
    '$uibModal', 'FileUploader', 'host', 'AuthService', '$window', '$translate', 'SubscriptionService'
];



// WEBPACK FOOTER //
// ./src/app/pages/account-information/account-information.controller.js